import React from 'react';

export default function PageHero({ eyebrow, height, title, em, subtitle, children, video }) {
  return (
    <div className="page-hero" style={{ height }}>
      <video className="page-hero-video" src={video} autoPlay loop muted playsInline />
      <div className="page-hero-overlay" />
      <div className="page-hero-content container">
        {eyebrow && <div className="page-hero-eyebrow">{eyebrow}</div>}
        {(title || em) && (
          <h1 className="page-hero-title">
            {title}{em && <em>{em}</em>}
          </h1>
        )}
        {subtitle && <p className="page-hero-sub">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
